module.exports = __webpack_public_path__ + "static/Wynajem-kserokopiarek-piotrkow-trybunalski-speedcopy-8d25faed95c407fe6d3ed340ea9c93b4.png";